import * as React from "react";
import { RouterState } from "react-router-redux";
import { Location } from "history";
import * as ReactGA from "react-ga";
import * as ReactPixel from "react-facebook-pixel";

// Init Google Analytics and Facebook Pixel
if (process.env.NODE_ENV === "production") {
  ReactGA.initialize(process.env.REACT_APP_GA_ID as string);
  ReactPixel.init(process.env.REACT_APP_FBP_ID as string);
}

function trackPage({ pathname }: Location) {
  ReactGA.set({ page: pathname });
  ReactGA.pageview(pathname);
  ReactPixel.pageView();
}

/**
 * HOC that adds page tracking via GA to whatever.
 */
const withPageTracking = <P extends RouterState>(
  Component: React.ComponentType<P>,
) => (props: P) => {
  if (process.env.NODE_ENV === "production" && props.location) {
    trackPage(props.location);
  }

  return <Component {...props} />;
};

export default withPageTracking;



// WEBPACK FOOTER //
// ./src/hoc/withPageTracking.tsx